
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/multi-instances.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/multi-instances.md?type=demo')
};